// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1Zc6l","footer-appear":"Footer_footer-appear__z2z0W"};